import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

// import './index.css';
import App from './containers/App';
import store from './store';
import { initialAppState } from './slices/appSlice';
// import '../../utils/drupal';

const renderApp = ({ initialState = {}, placeholder = '<div>Loading...</div>' }) => (
  <React.StrictMode>
    <Suspense
      fallback={<div dangerouslySetInnerHTML={{ __html: placeholder }}></div>}
    >
      <Provider store={store({
        app: { ...initialAppState, ...initialState },
      })}>
        <App/>
      </Provider>
    </Suspense>
  </React.StrictMode>
);

const container = document.getElementById('product-listing');
const root = createRoot(container);

const { drupalSettings: { avery_product_listing = {} } } = window;
root.render(renderApp({ initialState: avery_product_listing }));
